import { useStyles } from "./styles";

type ContentProps = {
  children: React.ReactElement<any, any>;
};

export function Content({ children }: ContentProps) {
  const styles = useStyles();
  return <div className={styles.root}>{children}</div>;
}
